import { Descriptions } from "antd";
import React, { memo, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { EntityBase } from "../../entities/common";

export interface DefaultEntityDescriptionProps {
  entity?: EntityBase;
  fields?:
    | Array<
        | string
        | {
            name: string;
            title?: string;
          }
      >
    | ((entity: any) => Array<
        | string
        | {
            name: string;
            title?: string;
          }
      >);
  presenter?: { [field: string]: (entity: any) => string | React.ReactNode };
  itemStyle?: React.CSSProperties;
}

export const DefaultEntityDescription = memo(({ entity, fields, presenter, itemStyle }: DefaultEntityDescriptionProps) => {
  const [t] = useTranslation();

  const getFieldValue = useCallback(
    (field: string) => {
      if (presenter && presenter.hasOwnProperty(field)) {
        return presenter[field](entity);
      }

      let value = entity ? entity[field] : "";

      if (value instanceof Array) {
        return value.map((v) => (
          <span key={v} className="mx-2 truncate">
            ({v})
          </span>
        ));
      }

      return value;
    },
    [entity, presenter]
  );

  const finalFields = useMemo(() => (fields ? (typeof fields === "function" ? fields(entity) : fields) : []), [entity, fields]);

  return (
    <Descriptions className="bg-white" column={{ xxl: 3, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }} bordered>
      {finalFields.map((field) => (
        <Descriptions.Item
          key={typeof field === "string" ? field : field.name}
          label={typeof field === "string" ? t(field) : field.title || t(field.name)}
          labelStyle={{ color: "gray" }}
          style={itemStyle}>
          {getFieldValue(typeof field === "string" ? field : field.name)}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );
});
